import { useMutation } from 'react-query'
import { axiosInstance } from '../api/http'

export const useLogin = () => {
  return useMutation(axiosInstance.mobile.usersControllerLogin)
}

export const checkHasPassword = (identifier: string) =>
  axiosInstance.mobile.usersControllerCheckHasPassword({ identifier })
